// extracted by mini-css-extract-plugin
export default {"container":"DbQh_AW3","inner":"scvaIUtY","buttonsWrapper":"dv3AU9cN"};